import React__default from 'react';
import { OVERLAY_TYPES } from '../../../t_types/enums/overlayTypes.js';

var SidebarIcon = function (_a) {
    var setGameControllerType = _a.setGameControllerType, sideIcon = _a.sideIcon;
    return (React__default.createElement("div", { className: 'pgc-left-side-button', onClick: function () { return setGameControllerType(OVERLAY_TYPES.Results); } },
        React__default.createElement("i", { className: sideIcon ? sideIcon : 'icon-double-arrow-right' })));
};

export { SidebarIcon };
